module.exports = __webpack_public_path__ + "static/media/heart25.abe646ea.svg";